import React, { useState } from "react";
import InputText from "./InputFilter";
import Container from "../../../components/Layout/Container";
import ContentBlock from "../../../components/Layout/ContentBlock";
import FilterMenu from "../../../components/Layout/FilterMenu";
import TableFilterBox from "../../../components/common/TableFilterBox";
import ContentValidation from "../../../components/common/ContentValidation";
import { ButtonInfo, SelectForm } from "../../../components/common/Buttons";
import {
  getNordrentOrders,
  getNordrentOrder,
  createInvoices,
  updateSerialNumber,
  setNordrentOrderSettings,
  callGenerateShipmentXlsx,
} from "../../../redux/Actions/orderAction";
import { setPickupAddressesOptions } from "../../../redux/Actions/options_action";
import { orderBulkByIds } from "../../../redux/Actions/bulk_shipment_action";
import { getCommentStateOption } from "../../../redux/Actions/comment_StateAction";
import { postTrRequests } from "../../../redux/Actions/tr_requests_action";
import { connect, useDispatch } from "react-redux";
import Pagination from "../../../components/Dashboard/items/Pagination";
import { AlertSuccess, AlertError } from "../../../components/common/Alerts";
import RangePickerComp from "../../../components/common/RangePickerComp";
import moment from "moment";
import { Select, Checkbox, Switch, Spin, Modal, Tooltip, Dropdown } from "antd";
import RegularModal from "./Modals/RegularModalsOrders";
import {
  antdMessageError,
  exportDocument,
  formatDatePlus,
  prettyDateFormat,
  uniqueArray,
} from "../../../helpers/Utils";
import { AiFillInfoCircle } from "react-icons/ai";

const { Option, OptGroup } = Select;
import {
  resetOrdersFilter,
  valueOrdersFilter,
  valueMultiOrdersFilter,
} from "../../../redux/Actions/filtersAction";
import ScrollYComponent from "./items/ScrollYComponent";
import OrderBulkAction from "./items/OrderBulkAction";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import {
  have_product_reference,
  onlyFiOrders,
  getAmazonValues,
  sortOrderShops,
  handleAmazonGroup,
  addAmazonGroupIfAll,
} from "../../../helpers/OrdersFunctionsGlobal";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { log } from "../../../helpers/log";
import OrderTable from "./items/OrderTable";
import { getCarriersActive } from "../../../redux/Actions/carrier_action";
import { getPaymentsTypesOptions } from "../../../redux/Actions/paymentAction";
import { getStatusesOptions } from "../../../redux/Actions/statusesAction";
import { setCountriesOptions } from "../../../redux/Actions/options_action";
import ModalBulkActionPreviewHistory from "./Modals/ModalBulkActionPreviewHistory";
import { Label, SelectInput } from "../../../components/globals";
import { shipment_types_options } from "../../../helpers/GlobalOptions";
import { exportedDocumentAction } from "../../../redux/Actions/exportedDocumentAction";
import useFetch from "../../../hooks/useFetch";
import { IconEye, IconEyeInvisible } from "../../../components/Layout/Icons";
import { AnimatePresence, motion } from "framer-motion";
import { getLocalStorage, setLocalStorage } from "../../../utils/localstorage";
import Axios from "axios";
import { InputSwitchComponent } from "../../../components/globals";
import { DebounceSelect } from "../../../components/common";
import OrdersAlertsModal from "../../../components/common/OrdersAlertsModal";

const { confirm } = Modal;

class AcceptedOrders extends React.Component {
  constructor() {
    super();
    this.state = {
      checkedAll: false,
      hidden_filters: false,
      layoutOfTable: [],
      carriers: [],
      payment_types: [],
      statuses: [],
      comment_state: [],
      comments_state_all: [],

      orders_checked: [],
      order_rows_checked: [],
      orders_checked_full: [],
      supplyings_checked: [],
      order_row_type: "Supply",
      reload_for_bulk_shipments: 1,
      modal_bulk_action_preview: false,
      isAlertModalVisible: false,
      alerts: [],
      orderAlerts: [],
      isAlertsLoading: true,
      showAlertMessage: true,
    };
    this.modalRef = React.createRef();
  }

  componentDidMount() {
    this.fetchData();
    getLocalStorage("orders_hidden_filters").then((hidden_filters) => {
      if (typeof hidden_filters == "boolean") {
        this.setState({
          hidden_filters,
        });
      }
    });
    // action
    if (this.props.location.search) {
      this.onFilter();
    } else if (!this.props.match.params.action) {
      this.onFilter();
    } else {
      this.onEdit("test", this.props.match.params.action);
      this.onFilter();
      this.props.history.push("/orders");
    }
    this.props.setPickupAddressesOptions();
    getCommentStateOption().then((res) => {
      if (res.data) {
        let commentAll = [];
        let comment_ka = [];
        let comment_management = [];
        let comment_logistic = [];

        res.data.forEach((item) => {
          if (!item?.name?.toLowerCase().includes("nordrent")) {
            return;
          }

          let newObj = {
            label: item.name,
            name: item.name,
            value: item.id,
            color: item.color,
            ordering: item.ordering,
            identifier: item.identifier,
            comment_type: item.comment_type,
            show_date: item.show_date,
          };
          commentAll.push(newObj);
          let cmst = item.comment_type;
          if (cmst == "comment_ka") {
            comment_ka.push(item);
          } else if (cmst == "comment_management") {
            if (onlyFiOrders(this.props.user.id)) return true;
            comment_management.push(item);
          } else {
            comment_logistic.push(item);
          }
        });
        const return_comment_state = [
          {
            title: "KA komentaras",
            children: comment_ka,
          },
          {
            title: "Vadybos komentaras",
            children: comment_management,
          },
          {
            title: "Logistikos komentaras",
            children: comment_logistic,
          },
        ];
        this.setState({
          comment_state: return_comment_state.filter(
            (option) => option.children.length > 0
          ),
          comments_state_all: commentAll,
        });
      }
    });
    // Nordrent: shops not shown — fetch only countries
    // (getOrderInitials also fetched order_shops, which the hidden store filter no longer needs)
    this.props.setCountriesOptions();
    this.layoutOfTableLocalStorage();
    getCarriersActive().then((carriers) => this.setState({ carriers }));
    getPaymentsTypesOptions().then(({ data: payment_types }) =>
      this.setState({ payment_types })
    );
    getStatusesOptions().then((statuses) => this.setState({ statuses }));
    // Nordrent: no alerts shown — skip order_alerts fetch
    // this.fetchOrderAlerts();

  }

  // Same duplicate-fetch guard as the bigbox orders page: redux rebuilds the
  // filter arrays on auth boot even when their contents are unchanged, and a
  // reference compare here refetched the list on every page load.
  sameFilterIds = (a, b) => {
    if (a === b) return true;
    if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((v, i) => String(v) === String(sortedB[i]));
  };

  componentDidUpdate(prevProps) {
    if (!this.sameFilterIds(prevProps.orderFilter.categoryFilter, this.props.orderFilter.categoryFilter)) {
      // Nordrent: no alerts shown — skip order_alerts fetch
      // this.fetchOrderAlerts();
      this.props.getOrders();
    }
  }

  fetchOrderAlerts = async () => {
    try {
      this.setState({ isAlertsLoading: true });
      const response = await Axios.get(
        "/api/v1/order_alerts?page=1&per_page=9999999"
      );
      this.setState({ orderAlerts: response.data.data });
      this.setState({ isAlertsLoading: false });
      if (response.data.data?.length > 0) {
        setTimeout(() => {
          this.setState({ showAlertMessage: false });
        }, 7000);
      }
    } catch (error) {
      console.error("Error fetching order alerts:", error);
      this.setState({ isAlertsLoading: false });
    }
  };

  fetchData = () => {
    this.setState({ loadingData: true });

    Axios.get(`/api/v1/carrier_groups`)
      .then((response) => {
        const transformedData = response.data.data.map((item) => ({
          ...item,
          value: item.id,
          label: item.title,
        }));

        this.setState({ carrierGroups: transformedData, loadingData: false });
      })
      .catch((error) => {
        console.error("Failed to fetch data:", error);
        this.setState({ loadingData: false });
      });

    Axios.get(`/api/v1/payment_groups`)
      .then((response) => {
        const transformedData = response.data.data.map((item) => ({
          ...item,
          value: item.id,
          label: item.title,
        }));

        this.setState({ paymentGroups: transformedData, loadingData: false });
      })
      .catch((error) => {
        console.error("Failed to fetch data:", error);
        this.setState({ loadingData: false });
      });

    Axios.get(`/api/v1/status_groups`)
      .then((response) => {
        const transformedData = response.data.data.map((item) => ({
          ...item,
          value: item.id,
          label: item.title,
        }));

        this.setState({ statusGroups: transformedData, loadingData: false });
      })
      .catch((error) => {
        console.error("Failed to fetch data:", error);
        this.setState({ loadingData: false });
      });
  };

  layoutOfTableLocalStorage = () => {
    const defaultStorage = [
      "Užsakymo data",
      "Eksp",
      "Order numeris",
      "Klientas",
      "Suma",
      "Prekes",
      "Likučiai",
      "DOCS",
      "Mokėjimo būdas",
      "Pristatymas",
      "Statusas",
      "KA komentarai",
      "Vadyba",
      "Logistika",
    ];
    const getLocalStorage = Array.isArray(
      JSON.parse(localStorage.getItem("orderTable"))
    )
      ? JSON.parse(localStorage.getItem("orderTable"))
      : defaultStorage;

    this.setState({
      layoutOfTable: getLocalStorage,
    });
  };

  reloadOrders = () => {
    this.props.getOrders();
  };

  openAlertModal = (alerts) => {
    this.setState({ isAlertModalVisible: true, alerts });
  };

  closeAlertModal = () => {
    this.setState({ isAlertModalVisible: false, alerts: [] });
  };

  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return "";
  }

  setGetParam(key, value) {
    if (history.pushState) {
      let params = new URLSearchParams(window.location.search);
      if (Array.isArray(value) && value[0] == "") {
        params.delete(key);
      } else if (value !== undefined && value.length > 0) {
        params.set(key, value);
      } else {
        params.delete(key);
      }

      var newUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?" +
        params.toString();
      window.history.pushState({ path: newUrl }, "", newUrl);
    }
  }

  onEdit = (_, id) => {
    this.props.getOrder(id);
    this.modalRef.current.openModal("OrderShowModal");
  };

  onCreate = () => {
    this.modalRef.current.openModal("OrderCreateModal");
  };

  setPagination = (page) => {
    this.props.setOrderSettings({
      page,
    });
  };
  setPageCount = (page_count) => {
    this.props.setOrderSettings({
      page_count,
      page: 1,
    });
  };

  tableColumnSelector = (selectedItems) => {
    this.setState({
      layoutOfTable: selectedItems,
    });
  };

  filterChange = async (e, date) => {
    if (date === "delivery") {
      let filters = {
        [date]: e,
      };
      const includesStore = e.includes("Atsiėmimas parduotuvėje");
      if (!includesStore) {
        filters.at_the_store = undefined;
      }
      await this.props.valueMultiOrdersFilter(filters);
    } else if (date) {
      await this.props.valueOrdersFilter({ name: [date], value: e });
    } else {
      this.props.valueOrdersFilter({
        name: e.target.name,
        value: e.target.value,
      });
    }
  };

  onFilter = () => {
    if (this.props.loading_orders) {
      return this.delayOnFilter();
    }
    let filterParams = [];
    if (this.props.orderFilter.order_shops !== undefined) {
      this.props.orderFilter.order_shops.forEach((each) => {
        filterParams.push(`&q[order_shop_id_in][]=${each}`);
      });
    }

    if (
      !onlyFiOrders(this.props.user.id) &&
      this.props.orderFilter.supp_date[0].length > 0
    ) {
      filterParams.push(
        `&q[order_rows_supplyings_date_gteq]=${this.props.orderFilter.supp_date[0]}`
      );
      if (this.props.orderFilter.without_shipping) {
        filterParams.push(`&q[order_rows_shipment_order_rows_id_blank]=1`);
      }
      if (this.props.orderFilter.carrying) {
        filterParams.push(`&after[carrying]=1`);
      }
    }
    if (
      !onlyFiOrders(this.props.user.id) &&
      this.props.orderFilter.supp_date[1].length > 0
    ) {
      filterParams.push(
        `&q[order_rows_supplyings_date_lteq]=${this.props.orderFilter.supp_date[1]}`
      );
    }

    if (this.props.orderFilter.invoice_email_state) {
      filterParams.push(
        `&q[invoice_email_state_eq]=${this.props.orderFilter.invoice_email_state}`
      );
    }

    if (this.props.orderFilter.id.length > 0)
      filterParams.push(`&q[id_order_eq]=${this.props.orderFilter.id}`);
    if (this.props.orderFilter.client.length > 0) {
      filterParams.push(
        `&q[customer_fulltext]=${encodeURIComponent(
          this.props.orderFilter.client.trim()
        )}`
      );
    }
    if (this.props.orderFilter.total_price_from) {
      filterParams.push(
        `&q[total_price_gteq_any]=${this.props.orderFilter.total_price_from}`
      );
    }
    if (this.props?.orderFilter?.reverse_vat) {
      filterParams.push(`&q[reverse_vat]=1`);
    }
    if (this.props?.orderFilter?.has_stock) {
      filterParams.push(`&q[has_stock]=1`);
    }
    if (this.props?.orderFilter?.auto_launch_exceptions) {
      filterParams.push(`&q[auto_launch_exceptions]=1`);
    }
    if (this.props.orderFilter.total_price_to) {
      filterParams.push(
        `&q[total_price_lteq_any]=${this.props.orderFilter.total_price_to}`
      );
    }
    if (this.props.orderFilter?.payment_status) {
      if (this.state.statusGroups?.length) {
        const selectedStatus = this.state.statusGroups.find(
          (status) => status.id === this.props.orderFilter.payment_status
        );
        if (selectedStatus) {
          const matchingStatusIds = selectedStatus.status_ids

          matchingStatusIds.map((statusId) => {
            filterParams.push(`&q[status_id_in][]=${statusId}`);
          });
        }
        console.log("selectedStatus:", selectedStatus);
      } else {
        const selectedStatus = this.state.statuses.find(
          (status) => status.value === this.props.orderFilter.payment_status
        );

        if (selectedStatus) {
          const matchingStatusIds = this.state.statuses
            .filter((status) => status.title === selectedStatus.title)
            .map((status) => status.value);

          matchingStatusIds.map((statusId) => {
            filterParams.push(`&q[status_id_in][]=${statusId}`);
          });
        }
      }
    }
    if (this.props.orderFilter?.supplier_id) {
      if (this.props.orderFilter.supplier_is_primary) {
        filterParams.push(
          `&q[order_rows_product_info_main_supplier_id_eq]=${this.props.orderFilter.supplier_id.value}`
        );
      } else {
        filterParams.push(
          `&q[order_rows_product_info_product_suppliers_available_quantity_gt]=0`
        );
      }
      filterParams.push(
        `&q[order_rows_product_info_product_suppliers_supplier_id_eq]=${this.props.orderFilter.supplier_id.value}`
      );
    }
    if (this.props.orderFilter?.product_qty_in_order) {
      filterParams.push(
        `&q[product_qty]=${this.props.orderFilter.product_qty_in_order}`
      );
    }
    if (this.props.orderFilter?.no_goods_supply) {
      filterParams.push(
        `&q[no_supply]=${this.props.orderFilter.no_goods_supply}`
      );
    }

    if (this.props.orderFilter.payer?.length > 0) {
      filterParams.push(
        `&q[billing_address_fulltext]=${encodeURIComponent(
          this.props.orderFilter.payer.trim()
        )}`
      );
    }
    if (
      this.props.orderFilter.delivery &&
      this.props.orderFilter.delivery.includes("Atsiėmimas parduotuvėje") &&
      this.props.orderFilter.at_the_store &&
      this.props.orderFilter.at_the_store !== "Visos"
    ) {
      filterParams.push(
        `&q[shipping_address_street_cont_any]=${this.props.orderFilter.at_the_store}`
      );
    }

    if (this.props.orderFilter.created) {
      filterParams.push(
        `&q[created_cont_any]=${this.props.orderFilter.created}`
      );
    }
    if (this.props.orderFilter?.ean?.length > 0) {
      filterParams.push(
        `&q[order_rows_product_info_ean_cont_any]=${this.props.orderFilter.ean}`
      );
    }
    if (this.props.orderFilter.date[0].length > 0)
      filterParams.push(
        `&q[order_date_gteq]=${this.props.orderFilter.date[0]}`
      );

    if (this.props.orderFilter.date[1].length > 0) {
      filterParams.push(
        `&q[order_date_lt]=${formatDatePlus(this.props.orderFilter.date[1])}`
      );
    }
    if (this.props.orderFilter.gift_code) {
      filterParams.push(`&q[order_cart_rules_title_cont]=${this.props.orderFilter.gift_code}`);
    }
    if (this.props.orderFilter.urgents)
      filterParams.push(`&q[urgent_true]=true`);

    if (this.props.orderFilter.ship_api_errors) {
      filterParams.push(`&q[shipments_api_errors_present]=1`);
    }
    if (this.props.orderFilter.invoice_api_errors) {
      filterParams.push(`&q[order_invoices_api_errors_present]=1`);
    }

    if (
      !!this.props.orderFilter.order_row &&
      this.props.orderFilter.order_row.length > 0
    ) {
      filterParams.push(
        `&q[order_rows_product_name_or_order_rows_product_reference_or_order_rows_product_upc_cont]=${this.props.orderFilter.order_row}`
      );
    }

    if (this.state?.paymentGroups?.length > 0) {
      const moduleNames = [];

      this.props.orderFilter.payment?.forEach?.((paymentGroupId) => {
        const matchingGroup = this.state.paymentGroups?.find?.(
          (group) => group.id === paymentGroupId
        );
        if (matchingGroup) {
          const groupModuleNames =
            matchingGroup.payments?.map((p) => p.module_name) || [];
          moduleNames.push(...groupModuleNames);
        }
      });

      moduleNames?.forEach?.((moduleName) => {
        filterParams.push(`&q[payment_module_in][]=${moduleName}`);
      });
    } else if (this.props.orderFilter.payment !== undefined) {
      if (this.props.orderFilter.payment?.length > 0)
        this.props.orderFilter?.payment?.forEach?.((id) => {
          filterParams.push(`&q[payment_in][]=${id}`);
        });
    }

    if (this.props.orderFilter.payment_reference)
      filterParams.push(
        `&q[payments_reference_cont]=${this.props.orderFilter.payment_reference}`
      );

    if (this.state.carrierGroups !== undefined) {
      const carrierIds = [];

      this.props.orderFilter.delivery?.forEach?.((deliveryId) => {
        const matchingGroup = this.state.carrierGroups?.find?.(
          (group) => group.id === deliveryId
        );
        if (matchingGroup) {
          carrierIds.push(...matchingGroup.carrier_ids);
        }
      });

      carrierIds?.forEach?.((id) => {
        filterParams.push(`&q[carrier_id_in][]=${id}`);
      });
    } else if (this.props.orderFilter.delivery !== undefined) {
      this.props.orderFilter.delivery.forEach((each) => {
        filterParams.push(`&q[carrier_name_in][]=${each}`);
      });
    }

    if (this.props.orderFilter.comment.length > 0) {
      this.props.orderFilter.comment.split(" ").forEach((item) => {
        filterParams.push(
          `&q[comments_body_or_comments_user_title_cont]=${item}`
        );
      });
    }

    // Serialnumber order_rows
    if (this.props.orderFilter.serialNumber_check) {
      const filterSerialNumberSwitch =
        this.props.orderFilter.serialNumber_switch;
      const filterParramString = `&q[order_rows_required_serial_number_true]=${filterSerialNumberSwitch}&q[order_rows_serial_number_present]=${filterSerialNumberSwitch
        ? !filterSerialNumberSwitch
        : filterSerialNumberSwitch
        }`;
      filterParams.push(filterParramString);
    }

    // Asigned Bills
    if (this.props.orderFilter.assigned_bills_check) {
      filterParams.push(
        `&q[assigned_bills_true]=${this.props.orderFilter.assigned_bills_switch}`
      );
    }

    // Shipments with api errors
    if (this.props.orderFilter.with_errors_check) {
      filterParams.push(`&q[shipments_api_errors_present]=1`);
    }
    if (this.props.orderFilter.with_tax_free) {
      filterParams.push(`&q[tax_free_declarations_tax_free_events_id_null]=0`);
    }

    if (this.props.orderFilter.stuck_in_delivery) {
      filterParams.push(`&stuck_in_delivery=1`);
    }

    if (this.props.orderFilter.not_picked_up) {
      filterParams.push(`&not_picked_up=1`);
    }
    if (this.props.orderFilter.shipments_created_at) {
      if (
        this.props.orderFilter.shipments_created_at[0] &&
        this.props.orderFilter.shipments_created_at[0].length > 0
      ) {
        filterParams.push(
          `&q[shipments_created_at_gteq]=${this.props.orderFilter.shipments_created_at[0]}`
        );
        filterParams.push(`&q[shipments_api_errors_null]=1`);
        if (this.props.orderFilter.shipment_type) {
          filterParams.push(
            `&q[shipments_shipment_type_eq]=${this.props.orderFilter.shipment_type}`
          );
        }
      }
      if (
        this.props.orderFilter.shipments_created_at[1] &&
        this.props.orderFilter.shipments_created_at[1].length > 0
      ) {
        filterParams.push(
          `&q[shipments_created_at_lteq]=${formatDatePlus(
            this.props.orderFilter.shipments_created_at[1]
          )}`
        );
      }
    }
    let filterSearchParamsUrl = [
      {
        key: "id",
        value: this.props.orderFilter.id,
      },
      {
        key: "client",
        value: this.props.orderFilter.client,
      },
      {
        key: "payer",
        value: this.props.orderFilter.payer,
      },
      {
        key: "date",
        value: this.props.orderFilter.date,
      },
      // {
      //   key: "payment",
      //   value: this.props.orderFilter.payment,
      // },
      {
        key: "order_row",
        value: this.props.orderFilter.order_row,
      },
      {
        key: "delivery",
        value: this.props.orderFilter.delivery,
      },
      {
        key: "comment",
        value: this.props.orderFilter.comment,
      },
      {
        key: "ean",
        value: this.props.orderFilter.ean,
      },
      {
        key: "assigned_bills_check",
        value: this.props.orderFilter.assigned_bills_check ? "1" : "",
      },
      {
        key: "serialNumber_check",
        value: this.props.orderFilter.serialNumber_check ? "1" : "",
      },
      {
        key: "with_errors_check",
        value: this.props.orderFilter.with_errors_check ? "1" : "",
      },
      {
        key: "stuck_in_delivery",
        value: this.props.orderFilter.stuck_in_delivery ? "1" : "",
      },
      {
        key: "not_picked_up",
        value: this.props.orderFilter.not_picked_up ? "1" : "",
      },
      {
        key: "at_the_store",
        value:
          this.props.orderFilter.delivery &&
            this.props.orderFilter.delivery.includes("Atsiėmimas parduotuvėje") &&
            ![undefined, "Visos"].includes(this.props.orderFilter.at_the_store)
            ? this.props.orderFilter.at_the_store
            : "",
      },
      {
        key: "invoice_email_state",
        value: this.props.orderFilter.invoice_email_state,
      },
      // {
      //   key: "comment_state",
      //   value: this.props.orderFilter.comment_state.map((item) => item.value),
      // },
    ];
    if (this.props.orderFilter.comment_state.length > 0) {
      let search_ka = [];
      let search_log = [];
      let search_man = [];
      this.props.orderFilter.comment_state.forEach((item) => {
        if (item.children2 == "KA komentaras") {
          if (item.value == "ka_0") {
            filterParams.push(`&q[comment_ka_id_null]=true`);
          } else {
            filterParams.push(`&q[comment_ka_id_in][]=${item.value}`);
          }
          search_ka.push(item.value);
        } else if (item.children2 == "Logistikos komentaras") {
          if (item.value == "log_0") {
            filterParams.push(`&q[comment_logistic_id_null]=true`);
          } else {
            filterParams.push(`&q[comment_logistic_id_in][]=${item.value}`);
          }
          search_log.push(item.value);
        } else if (item.children2 == "Vadybos komentaras") {
          if (item.value == "vd_0") {
            filterParams.push(`&q[comment_management_id_null]=true`);
          } else {
            filterParams.push(`&q[comment_management_id_in][]=${item.value}`);
          }
          search_man.push(item.value);
        }
      });
      filterSearchParamsUrl.push({
        key: "comment_state_ka",
        value: search_ka,
      });
      filterSearchParamsUrl.push({
        key: "comment_state_log",
        value: search_log,
      });
      filterSearchParamsUrl.push({
        key: "comment_state_man",
        value: search_man,
      });
    } else {
      filterSearchParamsUrl.push({
        key: "comment_state_ka",
        value: [],
      });
      filterSearchParamsUrl.push({
        key: "comment_state_log",
        value: [],
      });
      filterSearchParamsUrl.push({
        key: "comment_state_man",
        value: [],
      });
    }
    filterSearchParamsUrl.forEach((item) => {
      this.setGetParam(item.key, item.value);
    });

    this.props.setOrderSettings({
      params_filter: filterParams.join(""),
      page: 1,
    });
    this.clearChecked();
  };
  delayOnFilter = () => {
    if (this.props.loading_orders) {
      return setTimeout(() => {
        return this.delayOnFilter();
      }, 1000);
    }
    this.onFilter();
  };

  handleKeyDown = (e) => {
    if (e.key == "Enter") {
      this.onFilter();
    }
  };
  getDateFormat = (date) => {
    var d = moment(date);
    return date && d.isValid() ? d : "";
  };

  clearChecked = () => {
    this.setState(
      {
        orders_checked: [],
        supplyings_checked: [],
        order_rows_checked: [],
      },
      () => this.bulkDataSetter()
    );
  };

  clearFilter = async () => {
    this.clearChecked();
    await this.props.resetOrdersFilter();
    // await this.onFilter();
  };

  renderCustomButton = () => {
    return (
      <>
        {/* Nordrent: disabled "Bulk action" button (cross-system: courier shipment bulk + Rivile PO creation). */}
        {/* {!onlyFiOrders(this.props.user.id) && (
          <div className="float-left ml-1">
            <OrderBulkAction
              checkedArray={this.state.orders_checked}
              checkedArrayFull={this.state.orders_checked_full}
              comments_state={this.state.comments_state_all}
              order_rows_accepted={this.state.order_rows_checked}
              unCheck={(type, check_data) => {
                if (type == "orders") {
                  this.setState({
                    orders_checked: check_data,
                  });
                } else if (type == "modal_bulk_action_preview") {
                  this.setState({
                    modal_bulk_action_preview: true,
                  });
                } else {
                  this.setState({
                    order_rows_checked: check_data,
                  });
                }
              }}
              modalRef={this.modalRef.current}
            />
          </div>
        )} */}
        {/* Nordrent: disabled "Export" dropdown (cross-system: TR-request exports + shipment XLSX). */}
        {/* <ExportDropdown
          cleanUp={() =>
            this.setState({
              orders_checked: [],
              supplyings_checked: [],
              orders_checked: [],
            })
          }
          orderFilter={this.props.orderFilter}
          user={this.props.user}
          settings={this.props.settings}
          orders_checked={this.state.orders_checked}
          supplyings_checked={this.state.supplyings_checked}
          total_amount={this.props.total_amount}
        /> */}
        {/* Nordrent: disabled "Create invoices" dropdown (cross-system integration with Rivile). */}
        {/* {!onlyFiOrders(this.props.user.id) && (
          <>
            <div className="dropdown">
              <button
                className="btn btn-sm btn-dark float-right mr-1 dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Create invoices
              </button>
              <div
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                <button
                  className="dropdown-item"
                  onClick={() => this.createInvoices("selected")}
                >
                  Selected orders
                </button>
                <button
                  className="dropdown-item"
                  onClick={() => this.createInvoices("all")}
                >
                  All orders
                </button>
              </div>
            </div>
          </>
        )} */}

        <ButtonInfo
          className={"mr-3"}
          onClick={() =>
            this.setState(
              (prev) => ({
                hidden_filters: !prev.hidden_filters,
              }),
              () =>
                setLocalStorage(
                  "orders_hidden_filters",
                  this.state.hidden_filters
                )
            )
          }
        >
          {this.state.hidden_filters ? (
            <span>
              <IconEye color="#1F1A54" /> Show
            </span>
          ) : (
            <span>
              <IconEyeInvisible color="#1F1A54" /> Hide
            </span>
          )}{" "}
          filter
        </ButtonInfo>
      </>
    );
  };

  createInvoices = (action) => {
    if (action == "selected" && this.state.orders_checked.length == 0) {
      return antdMessageError("Not selected");
    }
    createInvoices(
      action,
      this.state.orders_checked,
      this.state.order_rows_checked,
      this.props.settings.params_filter
    );
  };

  handleSelected = (type, selected_id, default_array = []) => {
    // type: ["order", "order_row", "supplying"]
    let array = default_array;

    if (type == "order") array = this.state.orders_checked;
    else if (type == "order_row") array = this.state.order_rows_checked;
    else if (type == "supplying") array = this.state.supplyings_checked;
    return array.includes(selected_id);
  };

  checkSupplyingsByUserSuppliers = () => {
    const supplying_id = [];
    const order_row_id = [];
    const order_id = [];
    this.props.orders.forEach((order) =>
      order.order_rows.forEach((order_row) =>
        order_row.supplyings.forEach((supplying) => {
          if (!this.props.user.user_suppliers.includes(supplying.supplier_id)) {
            return;
          }
          supplying_id.push(supplying.id);
          order_row_id.push(order_row.id);
          order_id.push(order.id);
        })
      )
    );
    this.setState(
      {
        orders_checked: uniqueArray(order_id),
        order_rows_checked: uniqueArray(order_row_id),
        supplyings_checked: uniqueArray(supplying_id),
      },
      () => this.bulkDataSetter()
    );
  };

  handleCheck = (type, manual) => {
    let orders_checked = [...this.state.orders_checked];
    let orders_checked_full = [...this.state.orders_checked_full];
    let order_rows_checked = [...this.state.order_rows_checked];
    let supplyings_checked = [...this.state.supplyings_checked];

    if (manual.order_id) {
      manual.order_ids = [manual.order_id];
    }

    this.props.orders.forEach((order) => {
      let order_included = this.handleSelected(null, order.id, orders_checked);
      const manual_order_included = manual.order_ids
        ? manual.order_ids.includes(order.id)
        : false;

      if (order_included) {
        if (manual_order_included && !manual.order_row_id) {
          orders_checked = orders_checked.filter(
            (order_id) => order_id !== order.id
          );
          orders_checked_full = orders_checked_full.filter(
            (o) => o.id !== order.id
          );
          order_included = false;
        } else {
          if (manual_order_included) {
            orders_checked.push(order.id);
            orders_checked_full.push(order);
            order_included = true;
          }
        }
      } else {
        if (manual_order_included) {
          orders_checked.push(order.id);
          orders_checked_full.push(order);
          order_included = true;
        }
      }

      order.order_rows
        .filter((order_row) =>
          have_product_reference(order_row.product_reference)
        )
        .forEach((order_row) => {
          let order_row_included = this.handleSelected(
            null,
            order_row.id,
            order_rows_checked
          );

          if (order_row_included || !order_included) {
            if (
              (manual.order_row_id == order_row.id && !manual.supplying_id) ||
              !order_included
            ) {
              order_rows_checked = order_rows_checked.filter(
                (order_row_id) => order_row_id !== order_row.id
              );
              order_row_included = false;
            }
          } else {
            if (manual.order_row_id == order_row.id) {
              order_rows_checked.push(order_row.id);
              order_row_included = true;
            }
            if (!manual.order_row_id && order_included) {
              order_rows_checked.push(order_row.id);
              order_row_included = true;
            }
          }

          order_row.supplyings.forEach((supplying) => {
            let supplying_included = this.handleSelected(
              null,
              supplying.id,
              supplyings_checked
            );

            if (supplying_included || !order_row_included) {
              if (manual.supplying_id == supplying.id || !order_row_included) {
                supplyings_checked = supplyings_checked.filter(
                  (supplying_id) => supplying_id !== supplying.id
                );
              }
            } else {
              if (manual.supplying_id == supplying.id) {
                supplyings_checked.push(supplying.id);
              }
              if (
                !manual.supplying_id &&
                order_row_included &&
                !!this.props.user.user_suppliers?.length &&
                this.props.user.user_suppliers.includes(supplying.supplier_id)
              ) {
                supplyings_checked.push(supplying.id);
                supplying_included = true;
              }
            }
          });
        });
    });

    this.setState(
      {
        orders_checked: uniqueArray(orders_checked),
        orders_checked_full: uniqueArray(orders_checked_full),
        order_rows_checked: uniqueArray(order_rows_checked),
        supplyings_checked: uniqueArray(supplyings_checked),
      },
      () => {
        this.bulkDataSetter();
      }
    );
  };

  bulkDataSetter = () => {
    if (this.state.order_row_type !== "Extra services") {
      this.props
        .orderBulkByIds({
          orderIds: [],
          orderRowsIds: [],
          supplyingIds: [],
        })
        .then((res) => {
          this.setState({
            reload_for_bulk_shipments: this.state.reload_for_bulk_shipments + 1,
          });
        });
    } else {
      log("Hook orderbulkbyids");
      this.props
        .orderBulkByIds({
          orderIds: uniqueArray(this.state.orders_checked),
          orderRowsIds: uniqueArray(this.state.order_rows_checked),
          supplyingIds: uniqueArray(this.state.supplyings_checked),
        })
        .then((res) => {
          this.setState({
            reload_for_bulk_shipments: this.state.reload_for_bulk_shipments + 1,
          });
        });
    }
  };

  supplierCodeFetchOptions = async (value) => {
    try {
      let api_url = `/api/v1/suppliers?page=1&per_page=9999999&q[deleted_at_null]=1&q[rivile_supplier_code_null]=0&q[title_or_rivile_supplier_code_i_cont_any]=${value}`;

      const { data } = await Axios.get(api_url);
      const valArr = data?.data;
      return (
        valArr.map((e) => ({
          ...e,
          value: e.id,
          label: `${e.rivile_supplier_code} - ${e.title}`,
        })) || []
      );
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  render() {
    const customText = (
      <div>
        <span className="filterMenuText first">Total:</span>
        <span className="firstLength">
          {this.props.settings.total_amount &&
            this.props.total_amount == "loading" ? (
            <Spin />
          ) : (
            <span>
              {this.props.settings.total_amount
                ? this.props.total_amount
                : "**********"}{" "}
              {"\u20AC"}
              {this.props.settings.total_amount ? (
                <AiOutlineEyeInvisible
                  color="#D9D9D9"
                  className="text-xl cursor-pointer ml-2"
                  onClick={() =>
                    this.props.setOrderSettings({
                      total_amount: false,
                    })
                  }
                />
              ) : (
                <AiOutlineEye
                  color="#D9D9D9"
                  className="text-xl cursor-pointer ml-2"
                  onClick={() =>
                    this.props.setOrderSettings({
                      total_amount: true,
                    })
                  }
                />
              )}
            </span>
          )}
        </span>
      </div>
    );
    return (
      <>
        <Container
          location={{
            locationName: "Orders",
            locationUrl: this.props.match.url,
          }}
        >
          <>
            <ContentBlock
              extraClass="sticky-top sticky-extra"
              style={{ zIndex: 102 }}
            >
              <div className="d-flex align-items-center">
                <ScrollYComponent />

                <div style={{ width: "100%" }}>
                  <FilterMenu
                    totals={this.props.totals}
                    length={this.props.orders.length}
                    onChangeCountPage={this.setPageCount}
                    text2="Orders"
                    countPage={this.props.settings.page_count}
                    // Nordrent: hide Table layout / shipping / categories / status filter buttons
                    statusFilter={null}
                    categoryFilterModal={null}
                    tableLayout={null}
                    customText={customText}
                  />
                </div>
              </div>
            </ContentBlock>
            <AlertSuccess alertId={"order-s"} />
            <AlertError alertId={"order-e"} />
            <ContentBlock containerClass={"py-1"}>
              <TableFilterBox
                mr={1}
                extraClass="sticky-top"
                style={{
                  top: document.querySelector(".sticky-extra")
                    ? document.querySelector(".sticky-extra").offsetHeight + 7
                    : "50px",
                  zIndex: 10,
                }}
                clearFilter={
                  this.state.hidden_filters ? null : () => this.clearFilter()
                }
                button1={this.renderCustomButton()}
                onFilter={() => this.onFilter()}
                filter={!this.state.hidden_filters}
              >
                <AnimatePresence>
                  {!this.state.hidden_filters && (
                    <motion.div
                      className="filter-grid"
                      initial={{ height: 0 }}
                      animate={{ height: "auto" }}
                      exit={{ height: 0 }}
                      transition={{ duration: 0.2, ease: "easeInOut" }}
                    >
                      <React.Fragment>
                        {/* Nordrent: hidden "Order store" filter */}
                        {/* {!onlyFiOrders(this.props.user.id) && (
                          <div
                            className="px-1"
                            style={{ height: "fit-content" }}
                          >
                            <SelectForm
                              placeholder="Order store"
                              mode="multiple"
                              dropdownMatchSelectWidth={false}
                              options={sortOrderShops(this.props.order_shops)}
                              style={{ width: "100%" }}
                              onChange={(e) => {
                                const amz = getAmazonValues(this.props.order_shops);
                                const prev = addAmazonGroupIfAll(this.props.orderFilter.order_shops || [], amz);
                                this.filterChange(handleAmazonGroup(e, prev, amz), "order_shops");
                              }}
                              value={addAmazonGroupIfAll(this.props.orderFilter.order_shops || [], getAmazonValues(this.props.order_shops))}
                            />
                          </div>
                        )} */}
                        <div className="px-1 order-input-container">
                          <InputText
                            type="number"
                            // width={"0.75rem"}
                            number="1"
                            name="id"
                            value={this.props.orderFilter.id}
                            placeholder="Order no."
                            // blockSize="12rem"
                            style={{ width: "100%", fontSize: "14px" }}
                            onKeyDown={this.handleKeyDown}
                            onChange={(e) => this.filterChange(e)}
                          />
                        </div>
                        <div className="px-1 order-input-container">
                          <InputText
                            // width={"0.75rem"}
                            style={{ width: "100%", fontSize: "14px" }}
                            number="1"
                            name="client"
                            placeholder="Client"
                            value={this.props.orderFilter.client}
                            onKeyDown={this.handleKeyDown}
                            onChange={(e) => this.filterChange(e)}
                          />
                        </div>
                        <div className="px-1">
                          <InputText
                            // width={"0.75rem"}
                            style={{ width: "100%", fontSize: "14px" }}
                            number="1"
                            name="order_row"
                            placeholder="Goods"
                            onKeyDown={this.handleKeyDown}
                            value={this.props.orderFilter.order_row}
                            onChange={(e) => this.filterChange(e)}
                          />
                        </div>
                        <div className="px-1" style={{ height: "fit-content" }}>
                          <Label className="text-sm-label">
                            Comment statuses
                          </Label>
                          <Select
                            placeholder="Comment statuses"
                            mode="multiple"
                            allowClear
                            dropdownMatchSelectWidth={false}
                            value={
                              this.props.orderFilter.comment_state.map(
                                (item) => item.value
                              ) || undefined
                            }
                            style={{
                              minWidth: 150,
                              width: "100%",
                              maxWidth: 1000,
                              height: "fit-content",
                            }}
                            onChange={(_, arg) =>
                              this.filterChange(arg, "comment_state")
                            }
                            filterOption={(input, option) => {
                              if (option.children) {
                                return (
                                  option.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                );
                              }
                            }}
                          >
                            {this.state.comment_state.map((comState, index) => {
                              return (
                                <OptGroup
                                  key={`com${index}`}
                                  label={comState.title}
                                >
                                  {comState.children.map(
                                    (com_children, index) => (
                                      <Option
                                        key={`com_children_${com_children.id}_${index}`}
                                        children2={comState.title}
                                        value={com_children.id}
                                      >
                                        {com_children.name}
                                      </Option>
                                    )
                                  )}
                                </OptGroup>
                              );
                            })}
                          </Select>
                        </div>
                        <div className="px-1">
                          <InputText
                            type="number"
                            // width={"0.75rem"}
                            style={{ width: "100%", fontSize: "14px" }}
                            number="1"
                            name="comment"
                            placeholder="Comment"
                            onKeyDown={this.handleKeyDown}
                            onChange={(e) => this.filterChange(e)}
                            value={this.props.orderFilter.comment}
                          />
                        </div>
                        <div className="px-1 range-picker-span">
                          <div className="form-group order-input-form-group">
                            <Label className="text-sm-label">Date</Label>
                            <div>
                              <RangePickerComp
                                style={{ width: "100%" }}
                                placeholder={["Start time", "End time"]}
                                value={[
                                  this.getDateFormat(
                                    this.props.orderFilter.date[0]
                                  ),
                                  this.getDateFormat(
                                    this.props.orderFilter.date[1]
                                  ),
                                ]}
                                onChange={(e, args) =>
                                  this.filterChange(args, "date")
                                }
                              />
                            </div>
                          </div>
                        </div>

                        {/* Nordrent: hidden Alerts + Urgent counters */}
                        {/* <div className="urgent-counter-wrapper">
                          <div
                            className="mr-1"
                            onClick={() =>
                              this.openAlertModal([
                                {
                                  type: "Success",
                                  message: "Order processed successfully",
                                },
                              ])
                            }>
                            <span
                              className="filter-order-span"
                              style={{
                                color: "#bfbfbf",
                              }}
                            >
                              Alerts
                            </span>
                            <div
                              className="ml-2 text-center filter-orders-active"
                              style={{ background: "#17A2B8" }}
                            >
                              {this.state.isAlertsLoading ? (
                                <Spin className="custom_spinner" />
                              ) : (
                                this.state.orderAlerts?.length
                              )}
                            </div>
                          </div>
                          <div onClick={() =>
                            this.filterChange(
                              !this.props.orderFilter.urgents,
                              "urgents"
                            )
                          }
                            className="cursor-pointer">
                            <span
                              className="filter-order-span"
                              style={{
                                color: this.props.orderFilter.urgents
                                  ? "#FF0000"
                                  : "#bfbfbf",
                              }}
                            >
                              Urgent
                            </span>
                            <div
                              className="ml-2 text-center filter-orders-active"
                              style={{ background: "#FF0000" }}
                            >
                              {this.props.total_urgent == "loading" ? (
                                <Spin className="custom_spinner" />
                              ) : (
                                this.props.total_urgent
                              )}
                            </div>
                          </div>
                        </div> */}
                        {/*  */}
                        {/* <div className="mx-2 d-flex justify-content-center align-items-center">
                          <span
                            className="filter-order-span"
                            style={{
                              color: this.props.orderFilter.ship_api_errors
                                ? "#F7951E"
                                : "#bfbfbf",
                            }}
                            onClick={() =>
                              this.filterChange(
                                !this.props.orderFilter.ship_api_errors,
                                "ship_api_errors"
                              )
                            }
                          >
                            Ship ERR
                          </span>
                          <div
                            className="ml-2 text-center filter-orders-active"
                            style={{ background: "#F7951E" }}
                          >
                            {this.props.total_shipments_with_error ==
                            "loading" ? (
                              <Spin className="custom_spinner" />
                            ) : (
                              this.props.total_shipments_with_error
                            )}
                          </div>
                        </div>{" "} */}
                      </React.Fragment>
                    </motion.div>
                  )}
                </AnimatePresence>
              </TableFilterBox>
              <div>
                <ContentValidation
                  loader={this.props.loading_orders}
                  array={this.props.orders}
                  alertId_s="ordersAlert-s"
                  alertId_e="ordersAlert-e"
                >
                  <div className="col-12">
                    <div className="row">
                      <div className="col-4 d-flex align-items-center">
                        <small>
                          Selected orders:{" "}
                          <b>{this.state.orders_checked.length}</b>
                        </small>
                        <small>
                          , selected products:{" "}
                          <b>{this.state.order_rows_checked.length}</b>
                        </small>
                      </div>
                      <div className="col-4">
                        {this.state.order_row_type !== "Extra services" && (
                          <Pagination
                            className="mb-0"
                            setPagination={this.setPagination}
                            page={this.props.settings.page}
                            totals={this.props.totals}
                            pageCount={this.props.settings.page_count}
                          />
                        )}
                      </div>
                      <div className="col-4"></div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <style>{`
                      #orders input[type="checkbox"] {
                        display: none !important;
                      }

                      #orders td.align-middle.p-0 table {
                        display: none !important;
                      }
                    `}</style>
                    <OrderTable
                      orders={this.props.orders}
                      selected_orders_full={this.state.orders_checked_full}
                      totals={this.props.totals}
                      pickedSupplierId={this.props?.orderFilter?.supplier_id}
                      layoutOfTableIncl={(val) => {
                        if (val == "Vadyba" && onlyFiOrders(this.props.user.id))
                          return false;
                        return this.state.layoutOfTable.includes(val);
                      }}
                      handleCheck={this.handleCheck}
                      onEdit={this.onEdit}
                      orders_checked={this.state.orders_checked}
                      handleSelected={this.handleSelected}
                      //
                      updateSerialNumber={this.props.updateSerialNumber}
                      order_row_type={this.state.order_row_type}
                      reload_for_bulk_shipments={
                        this.state.reload_for_bulk_shipments
                      }
                      changeTableType={null}
                      supp_date={this.props.orderFilter.supp_date}
                    />
                    {this.state.order_row_type !== "Extra services" && (
                      <Pagination
                        setPagination={this.setPagination}
                        page={this.props.settings.page}
                        totals={this.props.totals}
                        pageCount={this.props.settings.page_count}
                      />
                    )}
                  </div>
                </ContentValidation>
              </div>
            </ContentBlock>
          </>
          <div id="modal-roots" />
          <RegularModal
            ref={this.modalRef}
            layoutOfTable={this.state.layoutOfTable}
            layoutOfTablesFunc={this.tableColumnSelector}
            avalaibleStatus={this.state.statuses}
            comments_state_all={this.state.comments_state_all}
            payment_types={this.state.payment_types}
            carriers={this.state.carriers}
          />
          <ModalBulkActionPreviewHistory
            active={this.state.modal_bulk_action_preview}
            closeModal={() =>
              this.setState({
                modal_bulk_action_preview: false,
              })
            }
            openOrder={(id) => this.onEdit(null, id)}
          />
        </Container>
        <OrdersAlertsModal
          visible={this.state.isAlertModalVisible}
          onCancel={this.closeAlertModal}
          alerts={this.state.orderAlerts}
          refreshAlerts={this.fetchOrderAlerts}
          onEdit={this.onEdit}
        />
        {this.state.orderAlerts?.length > 0 && this.state.showAlertMessage && (
          <div className="order-alert-alerts-message">
            <div className="order-alert-message-container">
              <AiFillInfoCircle color="#1890FF" size={14} />
              <p className="order-alert-message-text">
                You have new{" "}
                {
                  this.state.orderAlerts?.filter((alert) => !alert.seen_at)
                    ?.length
                }{" "}
                alerts
              </p>
            </div>
            <p
              className="order-alert-preview-link"
              onClick={() =>
                this.openAlertModal([
                  {
                    type: "Success",
                    message: "Order processed successfully",
                  },
                ])
              }
            >
              Preview
            </p>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  // Pagr order
  user: state.auth.user,
  orders: state.orders.orders,
  totals: state.orders.totals,
  total_amount: state.orders.total_amount,
  total_urgent: state.orders.total_urgent,
  total_invoices_with_error: state.orders.total_invoices_with_error,
  total_shipments_with_error: state.orders.total_shipments_with_error,
  loading_orders: state.orders.loading_orders,
  order_shops: state.options.order_shops,
  orderFilter: state.filters.orders,
  settings: state.orders.settings,
});
export default connect(mapStateToProps, {
  getOrders: getNordrentOrders,
  getOrder: getNordrentOrder,
  updateSerialNumber,
  resetOrdersFilter,
  valueOrdersFilter,
  valueMultiOrdersFilter,
  setOrderSettings: setNordrentOrderSettings,
  orderBulkByIds,
  setCountriesOptions,
  setPickupAddressesOptions,
})(AcceptedOrders);

const ExportDropdown = ({
  cleanUp,
  orderFilter,
  user,
  settings,
  orders_checked,
  supplyings_checked,
  total_amount,
}) => {
  const dispatch = useDispatch();
  const [openDropdown, setOpenDropdown] = useState(false);
  const exportContracts = (action) => {
    let url;
    let checked;
    let fileTitle = "Orders.xlsx";
    if (action == "selected") {
      url = "/api/v1/orders/export_orders_in_excel/";
      checked = orders_checked;
    } else if (action == "all") {
      url = `/api/v1/orders/export_orders_in_excel?${settings.params_filter}`;
      checked = [];
    } else if (action == "order_rows") {
      url = "/api/v1/orders/export_order_rows_in_csv";
      checked = supplyings_checked;
      fileTitle = "Goods_suppliers.csv";
    } else if (action == "unsent_csv") {
      url = `/api/v1/orders/export_order_unsended_csv?${settings.params_filter}`;
      checked = supplyings_checked;
      fileTitle = "orders_unsent.csv";
    }

    exportDocument(url, fileTitle, "POST", {
      checked,
    });
  };

  const items = [
    {
      key: "1",
      label: (
        <div
          onClick={() => {
            if (!orders_checked.length) return antdMessageError("Not selected");
            exportContracts("selected");
          }}
        >
          Export selected
        </div>
      ),
    },
    {
      key: "2",
      label: <div onClick={() => exportContracts("all")}>Export filtered</div>,
    },
    {
      key: "2-3",
      label: (
        <div onClick={() => exportContracts("order_rows")}>
          Export suppliers
        </div>
      ),
    },

    {
      key: "3",
      label: (
        <div onClick={() => exportContracts("unsent_csv")}>Export unsent</div>
      ),
    },
    {
      type: "divider",
    },
    // Nordrent: disabled TR-request export buttons (cross-system integration with TR).
    // {
    //   key: "4",
    //   label: (
    //     <div
    //       onClick={() => {
    //         if (supplyings_checked.length == 0)
    //           return antdMessageError("Not selected");
    //         confirm({
    //           title: "Are you sure?",
    //           icon: <ExclamationCircleOutlined className="text-primary" />,
    //           content: "You will not be able to undo this action",
    //           onOk: () => {
    //             postTrRequests({
    //               checked: supplyings_checked,
    //             }).then((res) => {
    //               if (res.success) {
    //                 cleanUp();
    //               }
    //             });
    //             console.log("OK");
    //           },
    //           onCancel() {
    //             console.log("Cancel");
    //           },
    //         });
    //       }}
    //     >
    //       Export selected to TR request
    //     </div>
    //   ),
    // },
    // {
    //   key: "5",
    //   label: (
    //     <div
    //       onClick={() => {
    //         if (total_amount ? total_amount > 300 : false)
    //           return antdMessageError("To many orders");
    //         confirm({
    //           title: "Are you sure?",
    //           icon: <ExclamationCircleOutlined className="text-primary" />,
    //           content: "You will not be able to undo this action",
    //           onOk: () => {
    //             postTrRequests({
    //               filters: settings.params_filter + "&filter=1",
    //             }).then((res) => {
    //               if (res.success) {
    //                 console.log("Successfully");
    //               }
    //             });
    //             console.log("OK");
    //           },
    //           onCancel() {
    //             console.log("Cancel");
    //           },
    //         });
    //       }}
    //     >
    //       Export filtered to TR request
    //     </div>
    //   ),
    // },
    {
      type: "divider",
    },
    {
      key: "6",
      label: (
        <div
          onClick={() => {
            if (
              !orderFilter.shipments_created_at ||
              !orderFilter.shipments_created_at[0]
            )
              return antdMessageError(
                "Select a 'Shipment date' using the filters"
              );
            confirm({
              title: "Are you sure?",
              icon: <ExclamationCircleOutlined className="text-primary" />,
              content: "You will not be able to undo this action",
              onOk: () => {
                dispatch(callGenerateShipmentXlsx());
              },
              onCancel() {
                console.log("Cancel");
              },
            });
          }}
        >
          Generate shipment XLSX
        </div>
      ),
    },
    openDropdown && {
      key: "7",
      label: <GenerateShipmentXlsx user_id={user.id} />,
    },
  ];

  return (
    <>
      <Dropdown
        arrow={true}
        trigger="click"
        open={openDropdown}
        onOpenChange={(event) => {
          setOpenDropdown(event);
          console.log({ event });
        }}
        menu={{ items }}
        placement="bottomRight"
      >
        <button
          className="btn btn-sm btn-dark float-right mr-3 dropdown-toggle"
          type="button"
        >
          Export
        </button>
      </Dropdown>
    </>
  );
};

const GenerateShipmentXlsx = ({ user_id }) => {
  const dispatch = useDispatch();
  const { loading, value, setReFetch } = useFetch(
    `/api/v1/settings?log_item=shipments_xlsx_${user_id}`
  );
  if (loading)
    return (
      <div className="text-center">
        <Spin />
      </div>
    );

  if (!value?.data?.updated_at) return null;

  if (value?.data?.body == "generating")
    return (
      <div className="text-silver">
        <Spin size="small" /> Generating shipment XLSX
      </div>
    );

  return (
    <div
      onClick={() => {
        dispatch(
          exportedDocumentAction({
            name: `shipments_xlsx_${user_id}.xlsx`,
            api_url: "/api/v1/downloads",
          })
        ).then(() => setReFetch());
      }}
    >
      Download your last generated shipment XLSX <br />(
      {prettyDateFormat(value.data.updated_at)})
    </div>
  );
};
